import styled from "styled-components";
import { ReactComponent as LogoSvg } from "./Logo.svg";
export const Logo = styled(LogoSvg)({
  position: "absolute",
  top: 60,
});
// export const Logo = () => <div>kaspersky</div>;
